import { combineReducers } from '@reduxjs/toolkit';

import marketingCopy, { MarketingCopyState } from './MarketingCopyReducer';
import digitalAsset from './DigitalAssetParentReducer';
import digitalAssetUpload from './DigitalAssetUploadReducer';
import priceSheets, { PriceSheetsState } from './PriceSheetsReducer';
import brands, { BrandState } from './BrandsReducer';
import attributeManagement, { AttributeManagementState } from './AttributeManagementReducer';
import languageSettings, { LanguageSettingsState } from './LanguageSettingsReducer';
import languageTranslation, { LanguageTranlationState } from './TranslationReducer';
import parentImportLogs from './ParentImportLogsReducer';
import parentExportLogs from './ParentExportLogsReducer';
import parentLogs from './ParentLogsReducer';
import accountDefaultValues, { AccountDefaultValuesState } from './AccountDefaultValuesReducer';
import parentCustomFields, { ParentCustomFieldsState } from './ParentCustomFieldsReducer';
import dynamicFieldList, { DynamicFieldListState } from './DynamicFieldListReducer';
import configurations, { ConfigurationsState } from './ConfigurationsReducer';

export type ParentState = {
  marketingCopy: MarketingCopyState;
  digitalAsset: any;
  digitalAssetUpload: any;
  priceSheets: PriceSheetsState;
  brands: BrandState;
  attributeManagement: AttributeManagementState;
  languageSettings: LanguageSettingsState;
  languageTranslation: LanguageTranlationState;
  parentImportLogs: any;
  parentExportLogs: any;
  parentLogs: any;
  accountDefaultValues: AccountDefaultValuesState;
  parentCustomFields: ParentCustomFieldsState;
  dynamicFieldList: DynamicFieldListState;
  configurations: ConfigurationsState;
};

const ParentReducer = combineReducers({
  marketingCopy,
  digitalAsset,
  digitalAssetUpload,
  priceSheets,
  brands,
  attributeManagement,
  languageSettings,
  languageTranslation,
  parentImportLogs,
  parentExportLogs,
  parentLogs,
  accountDefaultValues,
  parentCustomFields,
  dynamicFieldList,
  configurations,
});

export default ParentReducer;
